<template>
  <el-card shadow="always" style="text-align: center; height: 150px">
    <router-link :to="'/' + url"><i :class="icon" class="fa-4x"></i></router-link>
      <div>
        <router-link :to="'/' + url">{{ $t(this.name) }}</router-link>
      </div>
    </el-card>
</template>
<script>
export default {
  name: 'ReportBox',
  props: ['icon', 'name', 'url', 'type'],
  data () {
    return {
      
    }
  },
  created: function() {
  }
} 
</script>